<template>
	<a v-if="supported" href="#" @click="changeSort"><slot></slot><sym-icon v-if="sort !== 'no'" :name="sort === 'desc' ? 'caret-up-10' : 'caret-down-10'" class="fd-sortable-caret"></sym-icon></a>
	<template v-else><slot></slot></template>
</template>

<script setup lang="ts">
import {ColSortState} from "@fd/containers/agenda/AgendaUtils.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps<{
	sort: ColSortState,
	supported: boolean
}>();
const emit = defineEmits(["change"]);

function changeSort(e: MouseEvent) {
	e.preventDefault();
	if (props.sort === 'no') emit("change", "asc");
	else if (props.sort === 'asc') emit("change", "desc");
	else emit("change", "asc");
}
</script>

<style>

</style>